import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import HostsApi from './HostsApi';
import HostsActions from './Components/HostsActions';

let settings;

export default settings = {
    key: 'hosts',
    zone: 'hosts',
    path: '/hosts',
    title: "Hosts",
    endpoint: HostsApi.endpoint,
    modelName: 'Hosts',
    idKey: 'id',
    primaryKey: 'orgName',
    indexCaps: ["viewHosts"],
    viewCaps: ["viewHosts"],
    createCaps: ["createHosts"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Pending Verification",
                path: settings.path + "/status/pendingVerification",
                caps: settings.indexCaps
            },
            {
                label: "Verified",
                path: settings.path + "/status/verified",
                caps: settings.indexCaps
            },
            {
                label: "Rejected",
                path: settings.path + "/status/rejected",
                caps: settings.indexCaps
            },
            {
                label: "Revoked",
                path: settings.path + "/status/revoked",
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: HostsApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: [], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['orgName', 'companyName'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Status",
                key: "status",
                type: 'choice',
                options: [
                    { label: "Pending Verification", value: "pendingVerification" },
                    { label: "Verified", value: "verified" },
                    { label: "Rejected", value: "rejected" },
                    { label: "Revoked", value: "revoked" }
                ]
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Org Name",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Company Name",
                key: "companyName",
            },
            {
                label: "Contact Person",
                key: "contactPerson",
            },
            {
                label: "Available Tokens",
                key: "tokensAvailable",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <HostsActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: HostsApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['owner'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};